import { render, staticRenderFns } from "./SlaConfiguracaoAlertaCheckbox.vue?vue&type=template&id=61e495ab&"
import script from "./SlaConfiguracaoAlertaCheckbox.vue?vue&type=script&lang=js&"
export * from "./SlaConfiguracaoAlertaCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCheckbox,VTooltip})
